/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import WeeklyCalendar2 from "../Component/WeeklyCalendar2";

type NewScheduleProps = {
  className?: string;
};
const NewSchedule = ({ className }: NewScheduleProps) => {
  const [eventsState, setEvents] = useState<any[]>([]);
  console.log("eventsState", eventsState);
  return (
    <section className={className} data-testid="new-schedule">
      <p>Basic component placeholder.</p>
      <WeeklyCalendar2
        events={eventsState}
        weekStart={new Date()}
        slotMinutes={30}
        hoursRange={{ start: 8, end: 20 }}
        externalEvents={[
          {
            id: "call",
            title: "Client Call",
            // color: "#10b981",
            durationMinutes: 30,
          },
          {
            id: "call2",
            title: "Client Call2",
            // color: "#10b981",
            durationMinutes: 30,
          },
        ]}
        onExternalEventDrop={({ externalEvent, start, end }) => {
          const id = crypto.randomUUID();
          setEvents((prev) =>
            prev.concat({
              id,
              title: externalEvent.title,
              start,
              end,
              color: "red",
            })
          );
        }}
        onEventMove={({ event, start, end }) => {
          setEvents((prev) =>
            prev.map((e) => (e.id === event.id ? { ...e, start, end } : e))
          );
        }}
      />

      {/* <WeeklyCalendar
        events={eventsState}
        onEventCreate={({ template, start, end }) => {
          const id = crypto.randomUUID();
          setEvents((prev) =>
            prev.concat({
              id,
              title: template?.title ?? "New",
              start,
              end,
              color: template?.color,
            })
          );
        }}
        onEventUpdate={(id, updates) => {
          setEvents((prev) =>
            prev.map((e) => (e.id === id ? { ...e, ...updates } : e))
          );
        }}
        minuteStep={30}
        startHour={8}
        endHour={20}
        externalItems={[
          {
            id: "call",
            title: "Client Call",
            color: "#10b981",
            defaultDurationMinutes: 30,
          },
          {
            id: "call2",
            title: "Client Call2",
            color: "#10b981",
            defaultDurationMinutes: 30,
          },
        ]}
      /> */}
    </section>
  );
};

export default NewSchedule;
